import { 
  Bot, 
  Shield, 
  Code, 
  TrendingUp, 
  FileText, 
  Users, 
  Zap, 
  Eye, 
  Briefcase 
} from "lucide-react";

const agents = [
  { name: "Onboarding Agent", role: "Integration & Setup", icon: Users, color: "swarm-violet" },
  { name: "CISO Agent", role: "Compliance & Security", icon: Shield, color: "swarm-green" },
  { name: "DevOps Agent", role: "Infrastructure", icon: Code, color: "swarm-cyan" },
  { name: "Analytics Agent", role: "Metrics & Insights", icon: TrendingUp, color: "swarm-violet" },
  { name: "Documentation Agent", role: "Knowledge Base", icon: FileText, color: "swarm-cyan" },
  { name: "Support Agent", role: "Customer Success", icon: Bot, color: "swarm-green" },
  { name: "Automation Agent", role: "Workflow Execution", icon: Zap, color: "swarm-violet" },
  { name: "Monitoring Agent", role: "Real-time Observability", icon: Eye, color: "swarm-cyan" },
  { name: "Strategy Agent", role: "Business Intelligence", icon: Briefcase, color: "swarm-green" },
];

export const SwarmCrewSection = () => {
  return (
    <div className="relative" data-testid="swarmcrew-section">
      {/* Background glow */}
      <div className="absolute inset-0 bg-gradient-radial from-swarm-cyan/5 via-transparent to-transparent" />
      
      <div className="relative">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="section-label">SwarmCrew</div>
          <h2 className="section-title">Your AI Operations Team</h2>
          <p className="text-slate-400 max-w-2xl mx-auto text-lg">
            Dedicated AI agents for onboarding, integration, monitoring, and security. 
            Zero implementation consultants required.
          </p>
        </div>

        {/* Agent Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-6">
          {agents.map((agent, index) => {
            const Icon = agent.icon;
            const colorClasses = {
              'swarm-violet': {
                bg: 'bg-swarm-violet/10',
                text: 'text-swarm-violet',
                border: 'border-swarm-violet/20',
                glow: 'hover:shadow-[0_0_20px_rgba(139,92,246,0.2)]'
              },
              'swarm-cyan': {
                bg: 'bg-swarm-cyan/10',
                text: 'text-swarm-cyan',
                border: 'border-swarm-cyan/20',
                glow: 'hover:shadow-[0_0_20px_rgba(6,182,212,0.2)]'
              },
              'swarm-green': {
                bg: 'bg-swarm-green/10',
                text: 'text-swarm-green',
                border: 'border-swarm-green/20',
                glow: 'hover:shadow-[0_0_20px_rgba(16,185,129,0.2)]'
              }
            };
            const colors = colorClasses[agent.color];

            return (
              <div
                key={agent.name}
                className={`glass-card p-4 md:p-6 flex items-center gap-3 md:gap-4 transition-all duration-300 border ${colors.border} ${colors.glow} hover:border-opacity-50 animate-fade-in`}
                style={{ animationDelay: `${index * 50}ms` }}
              >
                <div className={`p-2 md:p-3 rounded-lg ${colors.bg} ${colors.text}`}>
                  <Icon className="w-5 h-5 md:w-6 md:h-6" />
                </div>
                <div className="min-w-0">
                  <h4 className="text-white font-medium text-sm md:text-base truncate">
                    {agent.name}
                  </h4>
                  <p className="text-slate-500 text-xs md:text-sm truncate">
                    {agent.role}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Meta narrative */}
        <div className="mt-10 text-center">
          <p className="text-slate-500 text-sm italic">
            "We use our own product to deliver our product."
          </p>
        </div>
      </div>
    </div>
  );
};

export default SwarmCrewSection;
